import api from './api';

export const userRequestService = {
  // Método para rejeitar um usuário - MUDOU PARA POST
  rejectUser: async (userId, rejectionReason) => {
    try {
      const response = await api.post(`/approve-user/`, {
        user_id: userId,
        status: 'RECUSADO',
        rejection_reason: rejectionReason
        // approved_at será preenchido automaticamente no backend
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Método para aprovar um usuário - MUDOU PARA POST
  approveUser: async (userId, permissions = {}, userType = 'GUARDIAN') => {
    try {
      const response = await api.post(`/approve-user/`, {
        user_id: userId,
        status: 'ACEITO',
        user_type: userType,
        permissions: permissions
        // approved_at será preenchido automaticamente no backend
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Método para listar user requests
getUserRequests: async (filters = {}) => {
  try {
    const response = await api.get('/list-user-requests/', {
      params: filters
    });
    return response.data;
  } catch (error) {
    throw error;
  }
},

  deleteOwnRequest: async (email) => {
    try {
      const response = await api.post('/delete-user-request/', { email: email.trim().toLowerCase() });
      return { ok: true, data: response.data };
    } catch (error) {
      const status = error.response?.status;
      const data = error.response?.data;
  
      if (status === 409) return { ok: false, kind: 'contact_support', data };
      if (status === 400) return { ok: false, kind: 'validation', data };
      return { ok: false, kind: 'unknown', data };
    }
  },
};